module.exports = __webpack_public_path__ + "img/3x3basketball.863ff392.svg";